// Build an .ics calendar from LOCALBOOST events with a day-before reminder (VALARM).
const TYPE_LABEL = {
  publication: "Publication", promotion: "Promotion", animation: "Animation",
  evenement: "Événement", campagne: "Campagne", tache: "Tâche",
};

function pad(n) { return String(n).padStart(2, "0"); }

function icsDate(year, month, day) {
  // month is 0-indexed; clamp day to valid range
  const last = new Date(year, month + 1, 0).getDate();
  const d = Math.min(Math.max(day, 1), last);
  return `${year}${pad(month + 1)}${pad(d)}`;
}

export function generateICS(events, { year, month } = {}) {
  const now = new Date();
  const y = year ?? now.getFullYear();
  const m = month ?? now.getMonth();
  const stamp = `${y}${pad(m + 1)}${pad(now.getDate())}T090000Z`;
  const lines = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//LOCALBOOST AI//Calendar//FR",
    "CALSCALE:GREGORIAN", "METHOD:PUBLISH", "X-WR-CALNAME:LOCALBOOST AI",
  ];
  (events || []).forEach((e) => {
    const dt = icsDate(y, m, e.day);
    const label = TYPE_LABEL[e.type] || "Action";
    lines.push(
      "BEGIN:VEVENT",
      `UID:${e.id || Math.random().toString(36).slice(2)}@localboost.ai`,
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${dt}`,
      `SUMMARY:${label} — ${(e.title || "").replace(/[\n,;]/g, " ")}`,
      `DESCRIPTION:Canal: ${(e.channel || "—").replace(/[\n,;]/g, " ")} · LOCALBOOST AI`,
      "BEGIN:VALARM",
      "ACTION:DISPLAY",
      `DESCRIPTION:Rappel — ${(e.title || "").replace(/[\n,;]/g, " ")}`,
      "TRIGGER;RELATED=START:-P1D",
      "END:VALARM",
      "END:VEVENT",
    );
  });
  lines.push("END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadICS(events, opts) {
  const ics = generateICS(events, opts);
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "planning_localboost.ics";
  a.click();
  URL.revokeObjectURL(url);
  return (events || []).length;
}
